import { HeaderAccountMenu } from '@/app/shell/Header/HeaderAccountMenu';
import { HeaderModeToggle } from '@/app/shell/Header/HeaderModeToggle';
import { WhatsNew } from '@/app/shell/versionCheck';
import icLogoDark from '@/assets/brand/logo-dark.svg';
import icLogoLight from '@/assets/brand/logo-light.svg';
import { useTrans } from '@/shared/hooks/useTranslation';
import { TrialClock } from '@/view/features/quota';
import { SupportPanel } from '@/view/features/support';
import { CustomTooltip } from '@/view/shared/Tooltip';
import { useAccountMenuViewModel } from '@/viewmodel/features/user';
import { useModeToggleViewModel } from '@/viewmodel/features/workspace';
import { useThemeViewModel } from '@/viewmodel/shared/theme';
import { Info } from 'lucide-react';
import { memo, useState } from 'react';
import { Link } from 'react-router-dom';

export default memo(function Header({ showLogo = true }: { readonly showLogo?: boolean }) {
  const { t } = useTrans();
  const { isDark } = useThemeViewModel();
  const modeToggle = useModeToggleViewModel();
  const accountMenu = useAccountMenuViewModel();
  const [supportOpen, setSupportOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 grid grid-cols-3 items-center w-full h-14 bg-surface">
      {showLogo ? (
        <Link to="/" className="shrink-0 justify-self-start">
          <img className="w-auto h-6 sm:h-8" src={isDark ? icLogoDark : icLogoLight} alt="Logo" />
        </Link>
      ) : (
        <span />
      )}

      {modeToggle.visible ? <HeaderModeToggle {...modeToggle} /> : <span />}

      <div className="flex items-center gap-2 shrink-0 justify-self-end">
        <TrialClock />
        <WhatsNew />
        <CustomTooltip tip={t('header.help')} placement="bottom">
          <button
            type="button"
            aria-label={t('header.help')}
            onClick={() => setSupportOpen(true)}
            className="flex items-center justify-center w-8 h-8 rounded-full text-muted-foreground hover:bg-surface-secondary hover:text-foreground transition-colors cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-border"
          >
            <Info size={18} />
          </button>
        </CustomTooltip>
        <SupportPanel isOpen={supportOpen} onClose={() => setSupportOpen(false)} />
        <HeaderAccountMenu {...accountMenu} />
      </div>
    </header>
  );
});
